import { memberPrefix } from "./utils";

export const linkingConfig = {
  screens: {
    DeferredComp: memberPrefix("deferred-comp"),
    Account: {
      screens: {
        AccountShow: memberPrefix("account"),
        AccountEdit: memberPrefix("account/edit"),
        AccountSettings: memberPrefix("account/settings"),
      },
    },
    AccountEditContact: {
      screens: {
        AccountEditContactInformation: memberPrefix("account/edit/contact"),
      },
    },
    EmailChange: {
      screens: {
        Initiate: memberPrefix("email-change/initiate"),
        Confirm: memberPrefix("email-change/confirm"),
        Success: memberPrefix("email-change/success"),
      },
    },
    DuesProxyPayment: memberPrefix("dues-proxy-payment/:id"),
  },
};

export const historyRules = [];
